import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Spin,
  Icon,
  Modal,
  Button,
  Divider,
  Drawer,
  Form,
  Select,
  message
} from 'antd';
import {
  ssrHandler,
  fetchMappedStatus,
  fetchUnmappedStatus,
  addNewStatus,
  updateUnmappedStatus,
  fetchServiceMetaData
} from '../actions/sessionActions';
import { getHostname } from '../utils/assetUtils';

const { Option } = Select;

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const columns = [
  {
    title: 'Courier Partner Status'
  },
  {
    title: 'Status Code'
  },
  {
    title: 'Shipment Cycle'
  },
  {
    title: 'Courier Partner'
  },
  {
    title: 'Remarks'
  },
  {
    title: 'Action'
  }
];

const DescriptionItem = ({ title, content }) => (
  <div
    style={{
      fontSize: 14,
      lineHeight: '22px',
      marginBottom: 7,
      color: 'rgba(0,0,0,0.65)'
    }}
  >
    <p
      style={{
        marginRight: 8,
        display: 'inline-block',
        color: 'rgba(0,0,0,0.85)'
      }}
    >
      {title}:
    </p>
    {content}
  </div>
);

DescriptionItem.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string
};

export class StatusMapping extends Component {
  static async fetchData({ dispatch }, match, route) {
    await dispatch(ssrHandler(route.path));
    await dispatch(fetchMappedStatus());
    await dispatch(fetchUnmappedStatus({}));
    await dispatch(fetchServiceMetaData());
  }

  constructor() {
    super();
    this.state = {
      visible: false,
      remarks: [],
      visibleDrawer: false,
      loading: false,
      statusIdx: -1,
      statusCode: -1,
      filter: {
        cps: [],
        shipmentCycle: ''
      }
    };
  }

  componentWillMount() {
    const { config, match } = this.props;
    if (match.path !== config.route && config.route !== '' && config.ssr) {
      this.props.fetchMappedStatus();
      this.props.fetchUnmappedStatus({});
      this.props.fetchServiceMetaData();
    }
  }

  showDrawer = e => {
    this.setState({
      visibleDrawer: true,
      statusIdx: Number(e.target.id)
    });
  };

  onClose = () => {
    this.setState({
      visibleDrawer: false,
      statusCode: -1,
      statusIdx: -1,
      loading: false
    });
  };

  handleOk = () => {
    this.setState({ loading: true });
    const { statusIdx, statusCode } = this.state;
    const { id } = this.props.statuses.unmapped.list[statusIdx];
    this.props.addNewStatus({ statusCode, id }).then(res => {
      if (res.metaCode === 200) {
        this.setState({
          loading: false,
          visibleDrawer: false,
          statusCode: -1,
          statusIdx: -1
        });
        message.success('Your data has been successfully submitted.');
        const { list } = this.props.statuses.unmapped;
        list.splice(statusIdx, 1);
        this.props.updateUnmappedStatus(list);
      } else {
        this.setState({ loading: false });
        message.error(res.error);
      }
    });
  };

  showModal = (e, remarks) => {
    this.setState({
      visible: true,
      remarks
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false
    });
  };

  handleChange = statusCode => {
    this.setState({
      statusCode
    });
  };

  handleSelectChange = (key, value) => {
    const { filter } = this.state;
    filter[key] = value;
    this.setState({ filter });
  };

  handleSubmit = () => {
    let { filter } = this.state;
    this.setState({ filter });
    this.props.fetchUnmappedStatus(filter);
  };

  reset = () => {
    let { filter } = this.state;
    filter = { cps: [], shipmentCycle: '' };
    this.setState({ filter });
    this.props.fetchUnmappedStatus(filter);
  };

  render() {
    const { metadata } = this.props;
    const { unmapped, mapped } = this.props.statuses;
    let hostname = 'track.clickpost.in';
    if (
      typeof window !== 'undefined' &&
      getHostname(window?.location?.href) === 'alerts-us.clickpost.ai'
    ) {
      hostname = 'track-us.clickpost.ai';
    }

    return (
      <div>
        <Row className="margin-bottom-10 view-header">
          <Col span={16}>
            <div className="global-search-wrapper" style={{ width: '100%' }}>
              <Select
                placeholder="Please select courier partner"
                value={
                  this.state.filter.cps.length > 0
                    ? this.state.filter.cps
                    : undefined
                }
                mode="multiple"
                style={{ width: '98%' }}
                onChange={value => this.handleSelectChange('cps', value)}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {metadata.cp.list.map((cp, i) => (
                  <Option key={i} value={cp.id}>
                    {cp.name}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={5}>
            <div className="global-search-wrapper" style={{ width: '100%' }}>
              <Select
                name="shipmentCycle"
                id="shipmentCycle"
                showSearch
                style={{ width: '96%' }}
                placeholder="Select Shipment Cycle"
                optionFilterProp="children"
                value={this.state.filter.shipmentCycle}
                onChange={value =>
                  this.handleSelectChange('shipmentCycle', value)
                }
                allowClear={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option key={0} value={''}>
                  Select All
                </Option>
                <Option key={0} value={1}>
                  Forward
                </Option>
                <Option key={1} value={2}>
                  Reverse
                </Option>
              </Select>
            </div>
          </Col>
          <Col span={3} className="text-center">
            <Button
              type="primary"
              className="pull-left"
              onClick={this.handleSubmit}
            >
              Submit
            </Button>
            <Button type="primary" onClick={this.reset} className="pull-right">
              Reset
            </Button>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {unmapped.isFetching ? (
              <Spin indicator={antIcon} />
            ) : (
              <Fragment>
                {unmapped.list.length <= 0 ? (
                  <div>&nbsp; No Data</div>
                ) : (
                  <Fragment>
                    <table
                      className={`ant-table cm-table ant-table-small width-100pt`}
                    >
                      <thead className="ant-table-thead">
                        <tr>
                          {columns.map((item, i) => (
                            <th className="padding-8" key={i}>
                              {item.title}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="ant-table-tbody">
                        {unmapped.list.map((item, i) => (
                          <tr key={i}>
                            <td className="padding-8">{item.cp_status}</td>
                            <td className="padding-8">{item.cp_status_code}</td>
                            <td className="padding-8">
                              {item.shipment_cycle_code === 1
                                ? 'Forward'
                                : 'Reverse'}
                            </td>
                            <td className="padding-8">
                              {item.courier_partner__name}
                            </td>
                            <td>
                              <Button
                                type="primary"
                                size="small"
                                disabled={
                                  item.remarks.length < 1 ||
                                  (item.remarks.length === 1 &&
                                    item.remarks[0] === '')
                                }
                                onClick={e => this.showModal(e, item.remarks)}
                              >
                                View
                              </Button>
                            </td>
                            <td className="padding-8">
                              <Button
                                id={i}
                                type="primary"
                                size="small"
                                onClick={e => this.showDrawer(e)}
                              >
                                Update
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <Drawer
                      title="New Status Mapping"
                      width={'50%'}
                      closable={false}
                      onClose={this.onClose}
                      visible={this.state.visibleDrawer}
                    >
                      {this.state.statusIdx > -1 ? (
                        <Fragment>
                          <Row>
                            <Col span={24}>
                              <DescriptionItem
                                title="Courier Partner Status"
                                content={
                                  unmapped.list[this.state.statusIdx].cp_status
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12}>
                              <DescriptionItem
                                title="Status Code"
                                content={
                                  unmapped.list[this.state.statusIdx]
                                    .cp_status_code
                                }
                              />
                            </Col>
                            <Col span={12}>
                              <DescriptionItem
                                title="Shipment Cycle"
                                content={
                                  unmapped.list[this.state.statusIdx]
                                    .shipment_cycle_code === 1
                                    ? 'Forward'
                                    : 'Reverse'
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col span={24}>
                              <DescriptionItem
                                title="Remarks"
                                content={unmapped.list[
                                  this.state.statusIdx
                                ].remarks.map((item, i) => (
                                  <p key={i}>
                                    {item}{' '}
                                    {unmapped.list[this.state.statusIdx].awbs &&
                                    unmapped.list[this.state.statusIdx].awbs[
                                      i
                                    ] ? (
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={`https://${hostname}/?cp_id=${
                                          unmapped.list[this.state.statusIdx]
                                            .courier_partner__partner_id
                                        }&waybill=${
                                          unmapped.list[this.state.statusIdx]
                                            .awbs[i]
                                        }`}
                                      >
                                        (Link:{' '}
                                        {
                                          unmapped.list[this.state.statusIdx]
                                            .awbs[i]
                                        }
                                        )
                                      </a>
                                    ) : (
                                      ''
                                    )}
                                  </p>
                                ))}
                              />
                            </Col>
                            {/* <Col span={24}>
                              <DescriptionItem
                                title="Remarks"
                                content={unmapped.list[
                                  this.state.statusIdx
                                ].remarks.join(', ')}
                              />
                            </Col> */}
                          </Row>
                          <Row>
                            <Col span={24}>
                              <DescriptionItem
                                title="Description"
                                content={
                                  unmapped.list[this.state.statusIdx]
                                    .cp_status_description
                                }
                              />
                            </Col>
                          </Row>
                          <Divider />
                          <Form layout="vertical" hideRequiredMark>
                            <Row gutter={16}>
                              <Col span={24}>
                                <Form.Item label="Status(Code)">
                                  <Select
                                    showSearch
                                    onChange={this.handleChange}
                                    value={
                                      this.state.statusCode === -1
                                        ? 'Please choose the status'
                                        : this.state.statusCode
                                    }
                                    onSearch={this.onSearch}
                                    allowClear
                                    filterOption={(input, option) =>
                                      option.props.children[0]
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                  >
                                    {mapped &&
                                      mapped.list.map((item, i) => (
                                        <Option
                                          key={i}
                                          value={item.uber_status_code}
                                        >
                                          {item.uber_status}(
                                          {item.uber_status_code})
                                        </Option>
                                      ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                            </Row>
                          </Form>
                        </Fragment>
                      ) : (
                        <Spin indicator={antIcon} />
                      )}
                      <div
                        style={{
                          position: 'absolute',
                          bottom: 0,
                          width: '100%',
                          borderTop: '1px solid #e8e8e8',
                          padding: '10px 16px',
                          textAlign: 'right',
                          left: 0,
                          background: '#fff',
                          borderRadius: '0 0 4px 4px'
                        }}
                      >
                        <Button
                          style={{
                            marginRight: 8
                          }}
                          onClick={this.onClose}
                        >
                          Cancel
                        </Button>
                        <Button
                          key="submit"
                          type="primary"
                          loading={this.state.loading}
                          onClick={this.handleOk}
                          disabled={this.state.statusCode < 0 ? true : false}
                        >
                          Submit
                        </Button>
                      </div>
                    </Drawer>
                  </Fragment>
                )}
              </Fragment>
            )}
          </Col>
        </Row>
        <Modal
          title="Remarks"
          visible={this.state.visible}
          onOk={this.handleCancel}
          onCancel={this.handleCancel}
        >
          <ul>
            {this.state.remarks.map((remark, i) => (
              <li key={i}>{remark}</li>
            ))}
          </ul>
        </Modal>
      </div>
    );
  }
}

StatusMapping.propTypes = {
  statuses: PropTypes.object,
  metadata: PropTypes.object,
  config: PropTypes.object,
  match: PropTypes.object,
  addNewStatus: PropTypes.func,
  fetchMappedStatus: PropTypes.func,
  fetchUnmappedStatus: PropTypes.func,
  updateUnmappedStatus: PropTypes.func,
  fetchServiceMetaData: PropTypes.func
};

StatusMapping.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  statuses: state.session.statuses,
  metadata: state.session.metadata
});

const mapDispatchToProps = dispatch => ({
  addNewStatus: query => dispatch(addNewStatus(query)),
  fetchMappedStatus: () => dispatch(fetchMappedStatus()),
  fetchUnmappedStatus: data => dispatch(fetchUnmappedStatus(data)),
  updateUnmappedStatus: list => dispatch(updateUnmappedStatus(list)),
  fetchServiceMetaData: list => dispatch(fetchServiceMetaData(list))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(StatusMapping)
);
